import { render, staticRenderFns } from "./newvirtualDeviceRTCurve.vue?vue&type=template&id=bf358b34&scoped=true&"
import script from "./newvirtualDeviceRTCurve.vue?vue&type=script&lang=js&"
export * from "./newvirtualDeviceRTCurve.vue?vue&type=script&lang=js&"
import style0 from "./newvirtualDeviceRTCurve.vue?vue&type=style&index=0&id=bf358b34&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf358b34",
  null
  
)

export default component.exports